import React from 'react';
import { Box, Grid, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

// 위험성 평가 아이콘 스타일 컴포넌트 정의
const RiskIconBase = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '40px',
  height: '40px',
  borderRadius: '50px',
}));

const HighRiskIcon = styled(RiskIconBase)({
  backgroundColor: 'red',
});

const MediumRiskIcon = styled(RiskIconBase)({
  backgroundColor: 'yellow',
});

const LowRiskIcon = styled(RiskIconBase)({
  backgroundColor: 'green',
});

const RiskText = styled('div')({
  fontSize: '20px',
  color: 'white',
});

const RiskMediumText = styled('div')({
  fontSize: '20px',
  color: 'black',
});

const RiskAssessment = ({ highCount = 0, mediumCount = 0, lowCount = 0 }) => {
  return (
    <Box sx={{ width: "100%", marginTop: 1 }}>
      <Grid container spacing={2}>
        <Grid item md={4}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <HighRiskIcon>
              <RiskText>상</RiskText>
            </HighRiskIcon>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Typography
                sx={{ marginTop: "15px", color: "white", fontSize: "25px" }}
              >
                {highCount}
              </Typography>
            </Box>
          </Box>
        </Grid>
        <Grid item md={4}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <MediumRiskIcon>
              <RiskMediumText>중</RiskMediumText>
            </MediumRiskIcon>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Typography
                sx={{ marginTop: "15px", color: "white", fontSize: "25px" }}
              >
                {mediumCount}
              </Typography>
            </Box>
          </Box>
        </Grid>
        <Grid item md={4}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <LowRiskIcon>
              <RiskText>하</RiskText>
            </LowRiskIcon>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Typography
                sx={{ marginTop: "15px", color: "white", fontSize: "25px" }}
              >
                {lowCount}
              </Typography>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default RiskAssessment;